export default __webpack_public_path__ + "static/media/Der_Lebensbaum_grande_boite.f4b60c14.jpg";